import { List } from 'antd';

import { GlobalOutlined, KeyOutlined, MessageOutlined, PhoneOutlined, UserOutlined, SafetyOutlined, DeleteOutlined } from '@ant-design/icons';
import { BugReportDrawer } from 'features/settings/bug-report';
import { SettingsItem, SettingsItemProps } from '../SettingsItem/SettingsItem';
import { useIntl } from 'react-intl';
import { ChangePhoneDrawer } from 'features/user/change-phone';
import { ChangeEmailDrawer } from 'features/user/change-email';
import { LanguageDrawer } from 'features/settings/change-language';
import { ChangePasswordDrawer } from 'features/settings/change-password';
import { TwoFactorDrawer } from 'features/settings/two-factor';
import { DeleteAccountDrawer } from 'features/settings/delete-account';

export const SettingsLayout = () => {
  const { formatMessage: t } = useIntl();
  const settings: SettingsItemProps[] = [
    {
      title: t({ id: 'screens.setting.setting.setting.nav.email' }),
      icon: <UserOutlined />,
      DrawerComponent: ChangeEmailDrawer
    },
    {
      title: t({ id: 'screens.setting.setting.setting.nav.phone' }),
      icon: <PhoneOutlined />,
      DrawerComponent: ChangePhoneDrawer
    },
    {
      title: t({ id: 'screens.setting.setting.setting.nav.password' }),
      icon: <KeyOutlined />,
      DrawerComponent: ChangePasswordDrawer
    },
    {
      title: t({ id: 'screens.validation.title' }),
      icon: <SafetyOutlined />,
      DrawerComponent: TwoFactorDrawer
    },
    {
      title: t({ id: 'settings.language.title' }),
      icon: <GlobalOutlined />,
      DrawerComponent: LanguageDrawer
    },
    {
      title: t({ id: 'screens.setting.setting.setting.nav.bugReport' }),
      icon: <MessageOutlined />,
      DrawerComponent: BugReportDrawer
    },
    {
      title: t({ id: 'screens.setting.delete.account.title' }),
      icon: <DeleteOutlined />,
      DrawerComponent: DeleteAccountDrawer
    }
  ];

  return (
    <List>
      {settings.map((item, index) => (
        <SettingsItem key={index} title={item.title} icon={item.icon} DrawerComponent={item.DrawerComponent} />
      ))}
    </List>
  );
};
